import { render } from "./IconCopy.vue?vue&type=template&id=b65f298e"
import script from "./IconCopy.vue?vue&type=script&lang=ts"
export * from "./IconCopy.vue?vue&type=script&lang=ts"
script.render = render

export default script